import { DataTableCollapsibleRow, Heading, Loader } from "@/components";
import useDetailedView from "./useDetailedView";
import { Button } from "@/components/ui";
import { Building2, Home } from "lucide-react";

const DetailedView = () => {
  const { breadcrumbData, title, 
    tableRef,
    columns,
    subColumns,
    level2Columns,
    tableData,
    onExpandStateChange,
    onExpandCollapse,
    isAllExpanded,
    isMetricDataLoading
  } = useDetailedView();

  return (
    <div className="p-4 md:p-6">
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading
            title={title}
            breadcrumbData={breadcrumbData}
          />
        </div>
        <Button
          type="button"
          onClick={onExpandCollapse}
          className="h-[36px] w-[120px] text-[14px]"
        >
          {isAllExpanded ? "Collapse All" : "Expand All"}
        </Button>
      </div>
        

      {isMetricDataLoading ? <Loader / > : 
        <DataTableCollapsibleRow
          ref={tableRef}
          columns={columns}
          nestedColumns={[subColumns, level2Columns]}
          variant="secondary"
          data={tableData}
          onExpandStateChange={onExpandStateChange}
          hideFooter
          hideHeader={{
            level2: true
          }}
          icons={{
            level1: <div className="p-2 flex items-center justify-center bg-blue-50 rounded-md shadow-sm">
              <Building2 className="h-5 stroke-primary" />
            </div>,
            level2: <div className="p-2 flex items-center justify-center bg-blue-50 rounded-md shadow-sm">
              <Building2 className="h-5 stroke-primary" />
            </div>,
            level3: <div className="p-2 flex items-center justify-center bg-blue-50 rounded-md shadow-sm">
              <Home className="h-5 stroke-primary" />
            </div>
          }}
        />
      }
    </div>
  )
}

export default DetailedView;